import { createDeferredI18n } from "#/shared/composables/useI18n";

import fallbackMessages from "#/shared/i18n/frontend.finder.json";

// Read directly off `i18n.global.t` by the result cards and their parts rather
// than via useI18n(), which can't resolve the plugin across the custom-element
// app boundary. `whenI18nReady` gates the root's first paint until the
// `frontend.finder` strings are hydrated so labels never flash keys.
export const { i18n, ready: whenI18nReady } = createDeferredI18n({ key: "finder", fallbackMessages });
